import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

// NOTE: Fetch all Landlords details
export const fetchLandlords = createAsyncThunk(
  "fetch/landlords",    
  async (arg) => {
    const query = generateQueryParams(arg);
    const response = await api.get(`user/manage-landlords?${query}`);
    return response.data;
  }
);

// NOTE: Delete User
export const deleteUser = createAsyncThunk(
  "delete/user",
  async (userId) => {
    const response = await api.delete(`user/delete-landlord/${userId}`);
    return response.data;
  }
);

// NOTE: Get User Profile
export const getUserProfile = createAsyncThunk(
  "get/user/profile",
  async (userId) => {
    const response = await api.get(`user/get-user/${userId}`);
    return response.data;
  }
);